import React from 'react';
import PropTypes from 'prop-types';

import HttpService from 'commonjs-tools/build/http-service';

var CURRENT_NODE_ID, SCRIPTS;
SCRIPTS = [];
CURRENT_NODE_ID = false;

function documentWriterOverride(node) {
    window.document.write = function (reponse) {
        node.innerHTML += reponse;
    }
}

function addScript(element) {
    if(typeof window === 'undefined') {
        return
    }

    documentWriterOverride(element.node);
    var div = element.node;
    if(div){
        div.appendChild(element.script);
    }
    else{
        console.log("this element is not there : " + element.node);
    }
    CURRENT_NODE_ID = element.node;
}

function onloadScript(document = {}) {
    return function () {
        if(typeof window === 'undefined') {
            return
        }
        window.document.write = this.DOCUMENT_WRITE;
        CURRENT_NODE_ID = false;
        if (!SCRIPTS || SCRIPTS.length === 0) {
            return;
        }
        //par le dernier element (plus simple)
        addScript(SCRIPTS.pop());
    }
}

function createScript(urlScript) {
    if(typeof window === 'undefined') {
        return
    }
    const script = React.createElement('script');
    console.log('loadScript createScript : ', script);
    script.setAttribute("type", "text/javascript");
    script.setAttribute("async", false);
    script.setAttribute("src", urlScript);
    script.onload = onloadScript(window.document);
    script.onerror =  () => {
        script.onerror = null;
        onloadScript(window.document);
        console.log('Script on error : ' + urlScript);
    };
    return script;
}

function loadScript(node, script) {
    console.log('loadScript node : ', node);
    console.log('loadScript script : ', script);
    var element = {node, script};
    if (!CURRENT_NODE_ID) {
        addScript(element);
        return;
    }
    SCRIPTS.push(element);
}


class Inject extends React.Component {
    static propTypes = {
        url: PropTypes.string,
    }

    httpService = new HttpService({})

    componentDidMount () {
        this.DOCUMENT_WRITE = window.document.write;

        const script = createScript(this.props.url);
        loadScript(this.refs.external, script)

        //
        // script.onload = event => {
        //     const scriptContent = event.path[0]
        //     console.log(' loaded! event', event);
        //     console.log(' loaded! path', scriptContent);
        //     console.log(' loaded! path', scriptContent.children);
        //     console.log(' loaded! path', scriptContent.outerHTML);
        //     console.log(' loaded! path', scriptContent.outerText);
        //     console.log(' loaded! path', scriptContent.text);
        //     console.log(' loaded! path', scriptContent.textContent);
        //
        //     console.log(' loaded! returnValue', event.returnValue());
        //     console.log(' loaded! target', event.target);
        //     console.log(' loaded! target', event.target.value);
        //
        //     console.log(' loaded! script', script);
        //     console.log(' loaded! script', script.html());
        //     console.log(' loaded! innerHTML', script.innerHTML);
        //     // hydrate(event, this.refs.external)
        //     // this.refs.external.removeChild(this)
        // };
        // this.refs.external.appendChild(script);
        //
        // this.httpService.get(this.props.url).then(data => {
        //     hydrate(data, this.refs.external)
        // })

    }

    render() {
        return <div ref="external"></div>
        // return <iframe ref="external" src={this.props.url}/>
    }
}

export default Inject;
